import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {Search} from 'lucide-react'
import './DataTableFilter.css'
//import { HoverTooltip } from '../HoverTooltip'
import HoverPopover from '../HoverPopover'

const DEBOUNCE_MS = 250

class DataTableFilter extends Component {
    constructor(props) {
        super(props)
        this.state = { inputValue: props.value || '' }
        this.debounceTimer = null
    }

    componentDidUpdate(prevProps) {
        // sync external resets (e.g. filter cleared by parent)
        if (prevProps.value !== this.props.value && this.props.value !== this.state.inputValue) {
            this.setState({ inputValue: this.props.value || '' })
        }
    }

    componentWillUnmount() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer)
    }

    handleChange = (event) => {
        const value = event.target.value
        this.setState({ inputValue: value })
        if (this.debounceTimer) clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
            this.props.onChange(value)
        }, DEBOUNCE_MS)
    }

    renderInput = () => (
        <input
            type="text"
            className="DataTableFilter-input"
            placeholder={this.props.placeholder || 'Search...'}
            onChange={this.handleChange}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            value={this.state.inputValue}
        />
    )

    renderTooltip = () => (
        <HoverPopover
            id="DataTableFilter-tooltip"
            message={this.props.tooltip || "Tooltip"}
            placement="left"
        >
            {this.renderInput()}
        </HoverPopover>
    )

    render() {
        return (
            <div className={'DataTableFilter'}>
                <Search size={18} className="DataTableFilter-icon"/>
                {this.props.tooltip ? this.renderTooltip() : this.renderInput()}
            </div>
        )
    }
}

DataTableFilter.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,

    placeholder: PropTypes.string,
    tooltip: PropTypes.string
}

export default DataTableFilter
